import 'core-js/modules/es6.set';
import 'core-js/modules/es6.map';

export const disableCorePrefetching = () => true;
